<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-22 
-->
<template>
  <div>
    <Layout>
      <Header>
        <home-header ref="header"></home-header>
      </Header>
      <Content>
        <keep-alive v-if="$route.meta.keepAlive">
          <router-view :key="activeDate" />
        </keep-alive>
        <router-view :key="activeDate" v-else />
      </Content>
      <Footer>
        <home-footer ref="footer" :btnList="btnList"></home-footer>
      </Footer>
      <fixed-btn ref="fixed-btn" :btnList="btnList" v-if="btnList.length"></fixed-btn>
      <login-modal ref="login"></login-modal>
      <ticket-tip ref="ticket-tip"></ticket-tip>
    </Layout>
  </div>
</template>
<script>
import HomeHeader from '@/components/pc/header.vue'
import HomeFooter from '@/components/pc/footer.vue'
import FixedBtn from '@/components/pc/fixedBtn.vue'
import TicketTip from '@/components/pc/ticketTip.vue'
import LoginModal from '@/components/pc/login.vue'
import { Aadvertisement, Ainsertrecords } from '@/service/app'
import { checkIfThereAreSendTickets } from '@/service/vbef'
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  components: {
    HomeHeader,
    HomeFooter,
    FixedBtn,
    LoginModal,
    TicketTip
  },
  provide() {
    return {
      debounce: this.debounce,
      reload: this.reload,
      login: this.login,
      clickBanner: this.clickBanner,
      globalInsertRecords: this.globalInsertRecords,
      checkIfThereAreSendTickets: this.checkIfThereAreSendTickets,
    }
  },
  created() {
    this.getBanner()
    if (this.user_key) {
      this.checkIfThereAreSendTickets()
    }
  },
  mounted() {
    // this.getTicketTip()
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout)
    }
  },
  data() {
    return {
      scrollTimeout: null, // 用于clearTimeout
      btnList: [],
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      uuserId: (state) => state.uuserId,
      uuid: (state) => state.uuid,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
  },
  methods: {
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
    handleScroll() {
      // 滚动时设置isScroll为true
      this.$refs['fixed-btn'].isScroll = true

      // 清除之前的setTimeout（如果存在）
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout)
      }

      // 设置setTimeout，在停止滚动1秒后设置isScroll为false
      this.scrollTimeout = setTimeout(() => {
        this.$refs['fixed-btn'].isScroll = false
      }, 500)
    },
    reload(cb) {
      this.activeDate = moment().unix()
      this.$nextTick(() => {
        if (cb) {
          cb
        }
      })
    },
    login(cb = '') {
      this.$refs['login'].beginLogin(cb)
    },
    async getBanner() {
      let res = await Aadvertisement({
        appAdPositionIds: this.language == 'zh' ? [68, 69, 70, 71] : [77, 79, 80, 81],
      })
      if (res.code == 0) {
        this.$set(this.$data, 'btnList', res.data)
      }
    },
    clickBanner(item, kw) {
      this.globalInsertRecords({
        contentId: item.appAdScheduleId,
        contentType: 45,
        viewType: 1,
        keyword: kw,
      })
      if (item.jumpType == 1) {
        const cb = () => {
          window.open(item.jumpOrientation.pointUrl, '_blank')
        }
        const urlsToCheck = [
          'vbdata.cn/signUp',
          'vbdata.cn/myTickets',
          'vbdata.cn/orderList',
          'vbdata.cn/userInfo',
          'vbdata.cn/ticketDetail',
        ]
        const pointUrl = item.jumpOrientation.pointUrl

        if (!this.user_key) {
          for (const url of urlsToCheck) {
            if (pointUrl.includes(url)) {
              this.login(cb)
              return
            }
          }
        }
        cb()
      }
    },
    async globalInsertRecords(item, cb) {
      let createTime = moment().format('YYYY-MM-DD HH:mm:ss')
      let params_arr = [
        {
          ...item,
          ...{
            createTime: createTime,
            xuserid: this.uuserId,
            imei: this.uuid,
            enterType: this.$route.meta.enter_type,
            loginPlatform: 6,
          },
        },
      ]
      let res = await Ainsertrecords({
        appAccessRecords: params_arr,
      })
      if (cb) cb()
    },
    getTicketTip() {
      this.$refs['ticket-tip'].modelIndex = true
    },
    async checkIfThereAreSendTickets() {
      let res = await checkIfThereAreSendTickets({})
      if (res.code == 0 && res.data.count > 0) {
        this.$refs['ticket-tip'].modelIndex = true
        this.$refs['ticket-tip'].count = res.data.count
      }
    }
  },
}
</script>
<style lang='stylus'>
.ivu-layout
  background #FFFFFF
  &-header
    line-height 1
    background-color #FFFFFF
    padding 0
    position fixed
    width 100%
    z-index 1001
    box-shadow 0px 1px 4px 0px rgba(14, 15, 20, 0.2)
  &-content
    padding-top 64px
    min-height 100vh
  &-footer
    background #FAFAFA
    padding 0
.loading-warpper
  display flex
  justify-content center
  margin-top 20px
.list-over
  margin-top 20px
  text-align center
  color #999
.nothing-warp
  padding 20px
  img
    width 200px
    height 124px
  .nothing-text
    margin-top 20px
    font-size 14px
  .btn
    margin-top 10px
    width 109px
    height 36px
    font-size 14px
    border-radius 5px
    line-height 36px
    &:hover
      background-color #F60
      border-color #F60
</style>